import { render, staticRenderFns } from "./StatsCampaignsTable.vue?vue&type=template&id=83e1a20e&scoped=true&"
import script from "./StatsCampaignsTable.vue?vue&type=script&lang=js&"
export * from "./StatsCampaignsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e1a20e",
  null
  
)

export default component.exports